import ApplicationComponent from "legacy/ApplicationComponent"
import ErrorMessage from "legacy/ErrorMessage"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { feetToInches, inchesToFeet } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class CreateContactBoat extends ApplicationComponent {
  constructor(props) {
    super(props)
    if (this.props.boat) {
      this.state = {
        name: this.props.boat.name || "",
        lengthOverall: inchesToFeet(this.props.boat.lengthOverall) || "",
        height: inchesToFeet(this.props.boat.height) || "",
        boatTypeNew: inchesToFeet(this.props.boat.boatTypeNew) || "",
        beam: inchesToFeet(this.props.boat.beam) || "",
        draw: inchesToFeet(this.props.boat.draw) || "",
        errorMessage: false,
        verb: "PATCH",
      }
    } else {
      this.state = {
        verb: "POST",
        name: "",
        lengthOverall: "",
        height: "",
        boatTypeNew: "",
        beam: "",
        draw: "",
        errorMessage: false,
      }
    }
    this.validator = validatorFactory()
    this.postForm = this.postForm.bind(this)
  }

  postForm() {
    const data = {
      name: this.state.name,
      length_overall: feetToInches(parseFloat(this.state.lengthOverall)),
      height: feetToInches(parseFloat(this.state.height)),
      beam: feetToInches(parseFloat(this.state.beam)),
      draw: feetToInches(parseFloat(this.state.draw)),
      boat_type: this.state.boatTypeNew,
    }
    if (this.state.verb === "PATCH") {
      data.encodedId = this.props.boat.encodedId
    }
    if (this.validator.allValid()) {
      $.ajax({
        url: this.props.dataUrl,
        data: JSON.stringify(data),
        type: this.state.verb,
        dataType: "json",
        contentType: "application/json",
        success: (result) => this.props.callback(result),
      }).fail(() => {
        this.setState({ errorMessage: true })
      })
    } else {
      this.validator.showMessages()
    }
  }

  render() {
    return (
      <div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <FormGroup
              label="Boat Name"
              value={this.state.name}
              name="name"
              onChange={this.handleInputChange}
            />
            {this.validator.message("name", this.state.name, "required")}
            <FormGroup
              inputType="feet"
              label="Length Overall"
              value={this.state.lengthOverall}
              name="lengthOverall"
              onChange={this.handleInputChange}
            />
            <FormGroup
              inputType="feet"
              label="Height"
              value={this.state.height}
              name="height"
              onChange={this.handleInputChange}
            />
          </div>
          <div>
            <FormGroup
              label="Boat Type"
              inputType="select"
              value={this.state.boatTypeNew}
              name="boatTypeNew"
              onChange={this.handleInputChange}
            >
              <option key="default" value="" disabled>
                Select Boat Type
              </option>
              {["sail", "power"].map((type) => (
                <option key={type} value={type}>
                  {_.capitalize(type)}
                </option>
              ))}
            </FormGroup>
            <FormGroup
              inputType="feet"
              label="Beam"
              value={this.state.beam}
              name="beam"
              onChange={this.handleInputChange}
            />
            <FormGroup
              inputType="feet"
              label="Draft"
              value={this.state.draw}
              name="draw"
              onChange={this.handleInputChange}
            />
          </div>
        </div>
        <div>
          {this.state.errorMessage && (
            <ErrorMessage>
              Something went wrong and the contact didn&apos;t save.
            </ErrorMessage>
          )}
        </div>
        <div className="flex justify-end space-x-1">
          <LegacyButton
            type="primary btn-sm"
            onClick={this.postForm}
            className="btn-sm"
          >
            Save
          </LegacyButton>
          {/* <LegacyButton type="grey btn-sm" onClick={cancel} className="btn-sm">Cancel</LegacyButton> */}
        </div>
      </div>
    )
  }
}

CreateContactBoat.propTypes = {
  boat: PropTypes.shape({
    name: PropTypes.string,
    lengthOverall: PropTypes.number,
    height: PropTypes.number,
    boatTypeNew: PropTypes.string,
    beam: PropTypes.number,
    draw: PropTypes.number,
    encodedId: PropTypes.string,
  }),
  dataUrl: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
}

export default CreateContactBoat
